export var ApplicationDebtSource;
(function (ApplicationDebtSource) {
    ApplicationDebtSource[ApplicationDebtSource["NotSet"] = 0] = "NotSet";
    ApplicationDebtSource[ApplicationDebtSource["Taxdata"] = 1] = "Taxdata";
    ApplicationDebtSource[ApplicationDebtSource["DebtRegistry"] = 2] = "DebtRegistry";
    ApplicationDebtSource[ApplicationDebtSource["Applicant"] = 3] = "Applicant";
    ApplicationDebtSource[ApplicationDebtSource["CustomerEngagement"] = 4] = "CustomerEngagement";
})(ApplicationDebtSource || (ApplicationDebtSource = {}));
//# sourceMappingURL=ApplicationDebt.js.map